// removed by extract-text-webpack-plugin
module.exports = {"rp-cogs":"app-pages-Library-Item-ItemDetail-ItemForm-COGSModal-COGSModalFieldArray-__COGSModalFieldArray___28Qj_","input-cogs":"app-pages-Library-Item-ItemDetail-ItemForm-COGSModal-COGSModalFieldArray-__COGSModalFieldArray___1vZsn"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Item/ItemDetail/ItemForm/COGSModal/COGSModalFieldArray/COGSModalFieldArray.css
// module id = 2171
// module chunks = 0